
function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref99c"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref99c"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
var $599019b355fc4fac$exports = {};
$parcel$extendImportMap({
    "5mzys": "screen-01.cce8aaf0.webp",
    "baUnB": "screen-02.1be0ef59.webp",
    "8PVf5": "screen-03.ddfdfcef.webp",
    "50W6t": "screen-04.3565a889.webp",
    "aq6Gu": "screen-05.e3a796f5.webp",
    "cnRAA": "screen-06.be016563.webp",
    "aX7ep": "screen-07.8f8e4168.webp",
    "bE46A": "screen-08.52ff19b9.webp",
    "gLHP4": "screen-09.ce65985f.webp",
    "aC6C1": "screen-10.e7211a90.webp",
    "iMSKz": "screen-11.4bc3addc.webp",
    "iJ57K": "screen-12.8c0d389c.webp"
});

const $82be4e23178679f6$var$header = document.querySelector(".header");
window.addEventListener("scroll", ()=>{
    if (window.scrollY > 40) $82be4e23178679f6$var$header.classList.add("scrolled");
    else $82be4e23178679f6$var$header.classList.remove("scrolled");
});
const $82be4e23178679f6$var$experienceItems = document.querySelectorAll(".works__item");
$82be4e23178679f6$var$experienceItems.forEach((item)=>{
    const button = item.querySelector(".works__button");
    button.addEventListener("click", ()=>{
        const isActive = item.classList.contains("active");
        $82be4e23178679f6$var$experienceItems.forEach((el)=>{
            el.classList.remove("active");
        });
        if (!isActive) item.classList.add("active");
    });
});
const $82be4e23178679f6$var$slider = document.querySelector(".slider");
var $d93b52f26700023d$exports = {};
$d93b52f26700023d$exports = $parcel$resolve("5mzys");


var $7cfd2fbea8189eb0$exports = {};
$7cfd2fbea8189eb0$exports = $parcel$resolve("baUnB");


var $a967fb14dd21be22$exports = {};
$a967fb14dd21be22$exports = $parcel$resolve("8PVf5");


var $e33d5a68832a3d2b$exports = {};
$e33d5a68832a3d2b$exports = $parcel$resolve("50W6t");


var $2ac179fa42a47d66$exports = {};
$2ac179fa42a47d66$exports = $parcel$resolve("aq6Gu");


var $d17df01580fae610$exports = {};
$d17df01580fae610$exports = $parcel$resolve("cnRAA");


var $9c0ceecd0acf80ae$exports = {};
$9c0ceecd0acf80ae$exports = $parcel$resolve("aX7ep");


var $d8ddd09807fd7efb$exports = {};
$d8ddd09807fd7efb$exports = $parcel$resolve("bE46A");


var $2e25b60600967688$exports = {};
$2e25b60600967688$exports = $parcel$resolve("gLHP4");


var $07a86d21d8d0d126$exports = {};
$07a86d21d8d0d126$exports = $parcel$resolve("aC6C1");


var $f2e3101fe75658cf$exports = {};
$f2e3101fe75658cf$exports = $parcel$resolve("iMSKz");


var $c8786e212a6227e9$exports = {};
$c8786e212a6227e9$exports = $parcel$resolve("iJ57K");


if ($82be4e23178679f6$var$slider) {
    const image = $82be4e23178679f6$var$slider.querySelector(".slider__image");
    const prevButton = $82be4e23178679f6$var$slider.querySelector(".slider__button--prev");
    const nextButton = $82be4e23178679f6$var$slider.querySelector(".slider__button--next");
    const current = $82be4e23178679f6$var$slider.querySelector(".slider__current");
    const total = $82be4e23178679f6$var$slider.querySelector(".slider__total");
    const images = [
        new URL($d93b52f26700023d$exports).href,
        new URL($7cfd2fbea8189eb0$exports).href,
        new URL($a967fb14dd21be22$exports).href,
        new URL($e33d5a68832a3d2b$exports).href,
        new URL($2ac179fa42a47d66$exports).href,
        new URL($d17df01580fae610$exports).href,
        new URL($9c0ceecd0acf80ae$exports).href,
        new URL($d8ddd09807fd7efb$exports).href,
        new URL($2e25b60600967688$exports).href,
        new URL($07a86d21d8d0d126$exports).href,
        new URL($f2e3101fe75658cf$exports).href,
        new URL($c8786e212a6227e9$exports).href
    ];
    console.log(images);
    let currentIndex = 0;
    let animationId = 0;
    image.src = images[0];
    total.textContent = String(images.length).padStart(2, "0");
    updateCounter();
    preloadImages();
    function updateCounter() {
        current.textContent = String(currentIndex + 1).padStart(2, "0");
    }
    function preloadImages() {
        const nextIndex = (currentIndex + 1) % images.length;
        const prevIndex = (currentIndex - 1 + images.length) % images.length;
        const next = new Image();
        next.src = images[nextIndex];
        const prev = new Image();
        prev.src = images[prevIndex];
    }
    function changeSlide(direction) {
        animationId++;
        const currentAnimation = animationId;
        image.classList.remove("fade-in");
        image.classList.add("fade-out");
        setTimeout(()=>{
            if (currentAnimation !== animationId) return;
            currentIndex = (currentIndex + direction + images.length) % images.length;
            image.src = images[currentIndex];
            updateCounter();
            preloadImages();
            image.classList.remove("fade-out");
            image.classList.add("fade-in");
            setTimeout(()=>{
                if (currentAnimation !== animationId) return;
                image.classList.remove("fade-in");
            }, 200);
        }, 100);
    }
    prevButton.addEventListener("click", ()=>changeSlide(-1));
    nextButton.addEventListener("click", ()=>changeSlide(1));
    document.addEventListener("keydown", (event)=>{
        if (event.key === "ArrowLeft") changeSlide(-1);
        if (event.key === "ArrowRight") changeSlide(1);
    });
    let startX = 0;
    let currentX = 0;
    let isDragging = false;
    let isPointerDown = false;
    const DRAG_DISTANCE = 90;
    function pointerDown(x) {
        startX = x;
        currentX = x;
        isPointerDown = true;
        isDragging = false;
    }
    function pointerMove(x) {
        if (!isPointerDown) return;
        currentX = x;
        const delta = currentX - startX;
        if (Math.abs(delta) > 12) isDragging = true;
    }
    function pointerUp() {
        if (!isPointerDown) return;
        const delta = currentX - startX;
        if (isDragging && Math.abs(delta) > DRAG_DISTANCE) changeSlide(delta < 0 ? 1 : -1);
        isPointerDown = false;
        isDragging = false;
    }
    image.addEventListener("mousedown", (event)=>{
        event.preventDefault();
        pointerDown(event.clientX);
    });
    window.addEventListener("mousemove", (event)=>{
        pointerMove(event.clientX);
    });
    window.addEventListener("mouseup", ()=>{
        pointerUp();
    });
    image.addEventListener("touchstart", (event)=>{
        if (event.touches.length !== 1 || window.visualViewport.scale > 1) return;
        pointerDown(event.touches[0].clientX);
    }, {
        passive: true
    });
    image.addEventListener("touchmove", (event)=>{
        if (event.touches.length !== 1 || window.visualViewport.scale > 1) return;
        pointerMove(event.touches[0].clientX);
    }, {
        passive: true
    });
    image.addEventListener("touchend", ()=>{
        pointerUp();
    }, {
        passive: true
    });
}
const $82be4e23178679f6$var$footer = document.querySelector(".footer");
// Только устройства с сенсорным экраном (iPhone, Android, iPad)
const $82be4e23178679f6$var$isTouchDevice = window.matchMedia("(pointer: coarse)").matches;
if ($82be4e23178679f6$var$footer && $82be4e23178679f6$var$isTouchDevice) {
    function updateBackground() {
        const rect = $82be4e23178679f6$var$footer.getBoundingClientRect();
        // Если верх футера находится в пределах экрана,
        // делаем фон body черным.
        const isFooterVisible = rect.top < window.innerHeight;
        document.body.classList.toggle("footer-visible", isFooterVisible);
    }
    window.addEventListener("scroll", updateBackground, {
        passive: true
    });
    window.addEventListener("resize", updateBackground);
    updateBackground();
}


//# sourceMappingURL=orbitalis.bf936286.js.map
